<template>
	<div class="sky-select-addEmail">
		<el-checkbox-group v-model="checkboxVal" @change="handleCheckedCitiesChange">
			<div v-for="item in websiteList" :key="item.id" class="addEmail">
				<el-checkbox class="item" :label="item.id" v-if="item.name !== null"
					>{{ `${item.name}(${item.serviceCode})` }}
				</el-checkbox>
				<el-checkbox class="item" :label="item.id" v-else
					>{{ `-(${item.serviceCode})` }}
				</el-checkbox>
				<!-- <el-form-item :error="!item.disabled ? errorObj[item.id] : ''">
					<el-select
						:disabled="item.disabled"
						v-model="valueObj[item.id]"
						filterable
						remote
						allow-create
						placeholder="请输入默认邮箱"
						:remote-method="val => remoteMethod(val, item)"
						@change="val => change(val, item)"
					>
						<el-option
							v-for="option in optionObj[item.id]"
							:key="option.id"
							:label="option.name"
							:value="option.name"
						>
						</el-option>
					</el-select>
				</el-form-item> -->
			</div>
		</el-checkbox-group>
	</div>
</template>
<script>
import customer from '@/backend/services/account/customer';
import { email } from '@/common/reg.js';
export default {
	props: {
		options: [Array, String, Function, Object, Promise],
		value: [Array],
		row: [Object],
	},
	data() {
		return {
			optionsSeach: [],
			checkboxVal: [],
			optionObj: {},
			valueObj: {},
			parmise: [],
			errorObj: {},
		};
	},
	computed: {
		websiteList: self => {
			let { options, checkboxVal } = self;
			let optionsCopy = [...options].map(item => {
				return {
					...item,
					disabled: !checkboxVal.includes(item.id),
				};
			});
			return optionsCopy;
		},
	},
	watch: {
		value: {
			handler(val) {
				this.checkboxVal = val.map(item => {
					this.valueObj[item.serviceSiteId] = item.defaultMailbox;
					return item.serviceSiteId;
				});
			},
			immediate: true,
		},
		websiteList: {
			handler(val) {
				let { optionObj, valueObj, errorObj } = this;
				val.forEach(item => {
					if ((!optionObj[item.id] && !valueObj[item.id]) || item.disabled) {
						optionObj[item.id] = [];
						valueObj[item.id] = '';
						errorObj[item.id] = '';
					}
				});
			},
			immediate: true,
		},
	},
	methods: {
		handleCheckedCitiesChange(value) {
			this.checkboxVal = value;
			this.inputValue();
		},
		remoteMethod(val, item) {
			this.dropDownList(val, item);
		},
		change(value, item) {
			this.errorObj[item.id] = !email.test(value) ? '请填写正确的邮箱' : '';
			this.$forceUpdate();
			this.inputValue();
		},
		async dropDownList(username, item) {
			let { id: serviceSiteId } = item;
			let accountId;
			if (this.row) {
				accountId = this.row.id;
			} else {
				accountId = '';
			}
			let { data } = await customer.dropDownList({
				accountId,
				serviceSiteId,
				username,
			});
			this.optionObj[item.id] = data;
			this.$forceUpdate();
		},
		inputValue() {
			let { checkboxVal, valueObj } = this;
			let inputValue = checkboxVal.map(serviceSiteId => {
				return {
					serviceSiteId,
					defaultMailbox: valueObj[serviceSiteId],
				};
			});
			this.$emit('input', inputValue);
		},
	},
};
</script>
<style scoped lang="scss">
.sky-select-addEmail {
  .addEmail {
    display: flex;

    .item {
      height: 50px;
      width: 300px;
    }
  }
}
</style>
